import { render, staticRenderFns } from "./Avatar.htm?vue&type=template&id=560b1e40&scoped=true&"
import script from "./Avatar.ts?vue&type=script&lang=js&"
export * from "./Avatar.ts?vue&type=script&lang=js&"
import style0 from "./Avatar.scss?vue&type=style&index=0&id=560b1e40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560b1e40",
  null
  
)

export default component.exports